<script>

import { useToast } from "vue-toastification";

import LoadingButton from '@/components/General/LoadingButton'
import LoadingScreen from '@/components/General/LoadingScreen'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

var sha512 = require('js-sha512');

//data
import { getToken,getDataToLogin,loginUser } from '@/services/serviceLogin';

export default {
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'LoginPage',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
			isLoading:true,
			isSending:false,
			user:[],
		}
	},
	
	mounted:function(){
		this.loadDefaultValues();
	},
	
	methods: {
		
		//default data
		loadDefaultValues:function(){

			this.isLoading=true
			
			getDataToLogin().then(response => {
				if(!response.statusText){
					console.log(response);
					this.isLoading=false
					this.userData = response.userData;
					this.user = response.user;
					
					if(this.user.isReg){
						this.$router.push({ path: '/' })
					}

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});	

		},
		
		//zobrazi heslo
		showPswd: function(){
			this.user.showInput = this.user.showInput===true?false:true;
		},
		
		
		checkData:function(){
			if(this.user.email && this.user.password){
				return true;
			}else{
				this.toast.warning(this.$t('msgCore.fillInAllData'));
				return false;
			}
		},
		
		//default data
		onGetStoken:function(){

			getToken().then(response => {
				if(!response.statusText){
					console.log(response);
					
					this.user.sToken = response.user.sToken;
					this.onLogin();

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});	

		},

		//prihlasenie
		onLogin:function(){
			
			if(this.checkData()){

				this.isSending=true;
				this.user.p = sha512(this.user.password)
				this.user.password = '';
				loginUser(JSON.stringify(this.user)).then(response => {
					
					if(!response.statusText){
						this.isSending=false;
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.successLogin'));
							
							if(localStorage.LastUrl){
								setTimeout(function(){ window.location.href = localStorage.LastUrl; }, 800);
								//localStorage.LastUrl='';
							}else{
								setTimeout(function(){ location.reload(); }, 800);
							}

						}else if(response.resCode==0){
							this.toast.error(this.$t('msgCore.badLoginRefreshForm'));
						}else if(response.resCode==2){
							this.toast.error(this.$t('msgCore.UnsuccessLogin'));
						}else if(response.resCode==3){
							this.toast.warning(this.$t('msgCore.badInputData'));
						}else if(response.data.resCode == 4){
							this.toast.error(this.$t('msgCore.AccountIsNotActivated'));
						}else if(response.data.resCode == 5){
							this.toast.error(this.$t('msgCore.AccountIsBlocked'));
						}else if(response.data.resCode == 6){
							this.toast.error(this.$t('msgCore.AccountExpired'));
						}else if(response.data.resCode == 7){
							this.toast.error(this.$t('msgCore.NumberOfLoginsExceeded'));
						}else if(response.data.resCode == 8){
							this.toast.error(this.$t('msgCore.EmailDoesNotExist'));
						}else if(response.data.resCode == 9){
							this.toast.error(this.$t('msgCore.BadPasswordLength'));
						}
					}else{
						this.isSending=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

			}
			
		},

		//reload
		reloadMe: function(){
			location.reload();
		}
		
	},	
				
	watch: {
		
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
	
		<div>
			<section id="login-box" class="box-flex">
				<div class="container-fluid">
					<div v-if="!user.isReg" class="row">
						<div class="col-12 col-md-4 offset-md-4 col-lg-3 offset-lg-4 bck">
						
							<div class="form-row">
								<div class="form-group col-md-12 col-12">
									<label><b>{{ $t('msgCore.Email') }}</b> </label>
									<input class="form-control form-control-sm" type="text" name="meno" v-model="user.email"/>
								</div>
							</div>
							
							<div class="form-row">
								<div class="form-group col-md-12 col-12">
									<label><b>{{ $t('msgCore.Password') }}</b> </label>
									<input :type="user.showInput ? 'text' : 'password'" name="heslo" autocomplete="new-heslo" class="form-control form-control-sm" v-model="user.password" :placeholder="$t('msgCore.Password')" v-on:keyup.enter="onGetStoken">
								</div>
							</div>

													
									
							<div class="form-row">
								<div class="input-group box-flex-right" >
									<LoadingButton :isSending="isSending" :isDisabled="(isSending)" v-on:click="onGetStoken()" color="primary" :label="'msgCore.Login'"></LoadingButton>
									
								</div>
							</div>
							
						</div>
					</div>	
				</div>
			</section>
		</div>
	</div>
</template>


